export default __webpack_public_path__ + "static/media/step-3.5cf63716.svg";